import { render, staticRenderFns } from "./GridCol.vue?vue&type=template&id=023dedc9&scoped=true"
import script from "./GridCol.vue?vue&type=script&lang=js"
export * from "./GridCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023dedc9",
  null
  
)

export default component.exports